module.exports = __webpack_public_path__ + "img/opp-direct-investment.66fe3255.png";